import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WebappnotificationService {

  constructor() { }
}


declare var require: any;
var SockJs = require("sockjs-client");
var Stomp = require("stompjs");

export class Message {
  content: string;
  style: string;
  dismissed: boolean = false;

  constructor (content , style?){
    this.content = content
    this.style = style || 'info'
  }
}

@Injectable({
  providedIn: 'root'
})

export class WebSocketServiceService {

  constructor() { }

   // Open connection with the back-end socket
   public connect() {
    let socket = new SockJs(`http://localhost:8080/socket`);

    let stompClient = Stomp.over(socket);

    return stompClient;
}

}